export default __webpack_public_path__ + "static/media/128x128.a487439c.jpg";